"use strict";

angular.module("licensure.services").factory("EXSessions", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessionSummaries", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getsession: function(id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessions/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getsessionsummary: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessions/" + id + '/Summary', {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getcorrespondence: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessions/Correspondence/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getdocuments: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessions/" + id + "/Documents", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getcandidatesessionresults: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessions/CandidateSessionResults/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (examSession) {

                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/ExamModule/ExamSessions/";

                if (!isUndefined(examSession.id)) {
                    method = "PUT";
                    url += examSession.id;
                }

                console.log("method ", method)

                $http({
                    method: method,
                    url: url,
                    data: examSession
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/ExamModule/ExamSessions/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

        };
    }
]);
